module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("1. THE NECESSITY FOR HERMENEUTICS")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Much ado about nothing?")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("‘Surely it’s a matter of common sense!’")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("‘I’ve been reading the Bible for thirty-five years, and I don’t need a lot of intellectual theories to tell me what it’s all about.’")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("‘The Bible is quite clear and understandable. And while we’re talking about it, what do you think Isaiah meant in this difficult passage?’")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("We have all heard similar expressions from time to time. On the one hand, the Bible is read by millions and largely understood. On the other hand, any thoughtful reader knows there are passages that are less clear than others. We also know that Christians who express the same essential understanding of the inspiration and authority of Scripture can disagree about important issues such as the interpretation of prophecy, the meaning of baptism, the normative nature of Acts 2, or the structure of the second coming of Christ. Of course, when a common enemy such as secularism or liberalism threatens evangelicals, then there is neither Baptist nor paedobaptist, amillennialist nor premillennialist, dispensationalist nor covenant theologian, Anglican nor Presbyterian, for all are one in Christ! Christians with a diversity of views will come together under the common umbrella of evangelicalism if they think they have sufficient reason. In less challenging times, however, differences can ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("become matters of potential and real division, and even hostility, being expressed under that broad evangelical umbrella. Suddenly the clarity of Scripture seems to mean, ‘It’s quite clear to me: why can’t you see what is obvious?’ Throwing proof texts at each other like so many grenades only results in unseemly shrapnel and much suspicion and hurt. But if I as an Anglican am to understand my Baptist brethren; if I as a Calvinist am to understand my Arminian brethren; if I as an amillennialist am to understand my premillennialist brethren; and if they are to understand me, then we must try to understand each other’s starting points and theological assumptions. This is where hermeneutics should play an important part. Even more basic is the desire of all of us simply to know and understand what God says to us in his word. We are concerned to be Christians in an alienated world, and we desire to see Christ glorified in this world. We want to hear and know God through his word.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Hermeneutics as a recognized discipline originally was mainly concerned to deal with problem texts in the Bible. The ordinary reader can easily skate over difficult readings with perhaps the intention to come back another time to try to figure them out. But what, after all, "), _c('i', [_vm._v("is ")]), _vm._v("a problem text? We conclude there is a problem when we cannot make sense of a passage. Mostly we recognize that problems arise because we, the readers, lack understanding of the theological, historical or cultural context of particular texts. Occasionally we may discover that there are real textual or linguistic problems. These show up where the Bible translators have provided their considered rendition while adding marginal notes such as ‘Hebrew uncertain’. But otherwise, we tend to regard the problem as being in the readers rather than inherent in the text. When we differ from other evangelicals on doctrinal matters, our inclination is to see the problem as lying in those who differ from us about something we regard as clear. Our confidence in the overall clarity of Scripture remains unshaken.")])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("What is/are hermeneutics?")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Hermeneutics is about communication, meaning and understanding. ‘Hermeneutics’, according to the "), _c('i', [_vm._v("Concise Oxford Dictionary")]), _vm._v(", is a plural noun. Common usage applies the plural word to the process of interpretation. So we will frequently use ‘hermeneutics’ as meaning the formal (academic) discipline, and treat it as a singular noun with a singular verb. Definitions of hermeneutics that are found in the recent literature include the following:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("The study of the locus of meaning and the principles of interpretation.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN4",
      "id": "ap_NFIN4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The science of reflecting on how a word or an event in the past time and culture may be understood and become existentially meaningful in our present situation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN5",
      "id": "ap_NFIN5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The task of finding out the meaning of a statement for the author and for the first hearers or readers, and thereupon to transmit that meaning to modern readers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN6",
      "id": "ap_NFIN6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("Defining the rules one uses when seeking out the meaning of Scripture."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN7",
      "id": "ap_NFIN7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Other authors imply the definition in their description of the goal or problems of hermeneutics, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The goal of biblical hermeneutics is to bring about an active and meaningful engagement between the interpreter and text, in such a way that the interpreter’s own horizon is re-shaped and enlarged."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN8",
      "id": "ap_NFIN8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The goal of interpretation . . . is ‘to know the Author’s/author’s intended meaning as it is expressed in the text’."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN9",
      "id": "ap_NFIN9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("The central problem of biblical hermeneutics [is] ‘How can the human word of a time long since vanished be understood as God’s word to the present?’"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN10",
      "id": "ap_NFIN10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These are fairly typical definitions, and it can be seen that simply to refer to interpretation is to raise a number of questions. These definitions are drawn from authors of differing theological stances, a fact that becomes more obvious when we investigate further the way these definitions are followed through. The reason for such differences is that the seemingly innocuous definitions carry a great variety of presuppositional baggage. Since we are dealing with the written documents of the Bible, different assumptions can be made about how meaning is related to the documents themselves. The definitions vary in their focus on the author/s, the text and the readers. Each of these dimensions will need some clarification if we are to make sense of the task.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("The necessity for hermeneutics")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The ‘ordinary, Bible-believing Christian’ may well question the need for such an enquiry and discipline as hermeneutics. After all, does it not make a simple, straightforward matter of reading the Bible unnecessarily complicated? Protestantism has always held to the notion of the clarity of Scripture. The rejection of priestcraft, of a supreme ecclesiastical authority that displaced the Bible, was a mark of the Reformation for the ordinary Christian. The medieval church did not use the Bible in either the original or the vernacular languages, but had recourse mainly to the Latin version. Church authority had resisted translations into the common language so that the Scriptures were not accessible to any but the clergy, and not always to them. The Reformers worked with a view to every man and woman having direct access to the Scriptures. Yet anyone who has attempted the task of translation will know that it is not a simple and straightforward process.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("It is not only the fact that the biblical texts were originally written in languages foreign to our own, and within cultural contexts very different from our own, that necessitates hermeneutics. Translation, reading and proclamation all include varying degrees of adaptation to the readers’ and hearers’ culture, a process we call contextualization.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN11",
      "id": "ap_NFIN11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Neither can be achieved without consideration of meaning. Translation involves recasting a text in a different language from its original. Contextualization involves the restating of the meaning of the text in a way that is understandable to the intended receivers. We also recognize that interpretation is not solely required by our remoteness from the time and culture of the texts. Cognition of words spoken to us by our immediate contemporaries requires some measure of interpretation. There is also the fact of our sinfulness and consequent inconsistency with our accepted principles of the inspiration and authority of the Bible as God’s word written.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("All human communication is done using symbols, either visual or auditory."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN12",
      "id": "ap_NFIN12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" The question we face in the process of interpretation is what relationship the symbol has to its referent — that is, to the thing it symbolizes. For example, the same word-symbol may occur in two different languages and mean totally different things. Again, the same sentence in a range of different contexts may mean something different in each context. The same symbol, for example the "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("number 60 inside a red circle, on a sign by the roadside, can mean different things in different countries.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN13",
      "id": "ap_NFIN13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" The context of a given word, sentence or paragraph may be so far removed from the world of the reader or hearer as to be open to misunderstanding or incomprehension. The function of hermeneutics could be stated as the attempt to bridge the gap between the text inside its world and the readers/hearers inside their world. We attempt this bridging because we are engaging in the quest for the application of the significance of the biblical text to ourselves in this twenty-first century.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("As already noted, we take our stand on certain presuppositions or assumptions when we are involved in this process. A lot of confusion could be avoided if interpreters recognized and owned the assumptions they make in seeking the meaning of any act of communication. One key assumption that most Christians make about the Bible is that the meaning of the text has significance, not only for the original hearers or readers, but also for others, including us. Thus we recognize a process of moving from what it meant then to what it means now. This may be thought of as beginning with a process of exegesis of the text in order to understand what it originally meant. This is followed by relevant hermeneutical procedures to bridge the gap between the text and us. Finally, there is the application of this meaning to us and the relaying of it, perhaps across a further gap, to others."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN14",
      "id": "ap_NFIN14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" In other words, the divine revelation of Scripture has validity for all time even if the significance of certain texts undergoes some kind of transformation. Thus, for example, the word of the Lord through Moses the prophet to the Israelites in the wilderness, about the ritual requirements of the service of the tabernacle, has meaning and significance for us, but it is not the same meaning and significance it had for the Israelites. The historical, geographical and theological contexts have all changed.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("We acknowledge the hermeneutical task when reading the Bible. We are aware of at least some of the possibilities for the way words and language can be used. We recognize the language gap between the ancient writer and ourselves. We also have to account for the historical and cultural gaps between the ancient text and ourselves. With the Bible we also start with "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("certain assumptions about the ultimate responsibility for its authorship and its authority. While acknowledging the divine authorship, we also take account of the human authors and their languages. We recognize the difficulties of translating from Hebrew, Aramaic and Greek into our own language. We know that our language is constantly changing and that our contemporary English can be quite distant from older translations.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN15",
      "id": "ap_NFIN15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" We might summarize some of the driving forces for a discipline of hermeneutics in terms of what separates the receiver of a communication from the message and the sender. Thus various kinds of gap exist between the text and us. These all relate to each other and often overlap quite a lot. They include the following.")]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-001"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The language gap")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This suggests that the matter can be dealt with by the simple act of having specialists in the biblical languages and our own language to translate the text. We will consider some of the complications of translation in chapter 18. You need only think of the differences between various Bible translations into English to be able to anticipate some of the problems involved. At its base, this gap concerns the need to obtain an accurate translation from the Hebrew, Aramaic and Greek texts of the Bible into our own language. That is not as simple as it sounds, for there are many significant regional and national differences between English-speaking peoples of the world."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN16",
      "id": "ap_NFIN16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-002"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The culture gap")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This can involve a host of matters relating to the world of the Bible, and the many differences between it and our own world. An educated Westerner would presumably have only moderate difficulty in bridging such gaps, "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("particularly if there were background resources available. We can learn to appreciate and make allowances for such gaps that exist between Ancient Near Eastern culture and modern Western culture. Even children at Sunday school soon learn to recognize the basics of the culture in the biblical world. They expect differences in dress, food and methods of transport. They know that they are dealing with a pre-industrial age that has only the rudiments of technology. It is a world of swords, spears and arrows; a world devoid of public transport and hospitals; a world without explosives and computers. The cultures of the various world-views and religions of the biblical world are different from our modern culture. In short, it is a world that is vastly different from ours, and yet it is similar enough not to be totally alien.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The history gap")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("This relates very closely to the culture gap, but also includes the problem of understanding the events recorded in biblical narrative for their historical value. Since the significance of the Christian faith rests upon key events in history, we must be concerned to understand the kind of history writing of the biblical narratives and how they give a coherent account of these events.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN17",
      "id": "ap_NFIN17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Reconstructing the historical events and understanding how they fit into the larger picture of world history becomes important. The Bible places great importance on certain events that modern historians either discount or regard as unimportant.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-004"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The literature gap")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As we are dealing with ancient documents, the question of how ancient authors wrote is a key matter for hermeneutics. This means that types, or genres, of literature, as well as the multitude of idioms and literary devices, will affect the way we interpret the literature. For example, it is obvious that the biblical historians did not set out only to report historical events in a clinical, factual way."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN18",
      "id": "ap_NFIN18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Like all historians, they were selective and presented a point of "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("view. Nor can we assume that chronological order is the only way a string of events can be recorded. Once we get into the realm of genre and literary device we can see how easy it is to misunderstand, and thus to misinterpret, a given text.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-005"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The textual gap")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One area of scholastic endeavour that is foundational for hermeneutics is textual criticism. Because we do not possess any of the original biblical documents (autographs), we are thus reliant on the transmission of the text by handwritten texts until the invention of the printing press. Even the non-technically trained Bible reader will recognize this problem from the occasional footnotes that occur in most standard translations, which draw attention to textual variants or uncertainties of translation because of obscurities in the accepted text. Only those instructed in textual matters would appreciate the differences in the New Testament text behind the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("KJV")]), _vm._v(" (and "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NKJV")]), _vm._v(") from the text used for many other standard versions.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-006"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The intended reader/hearer gap")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Humanly speaking, we are not the intended readers or hearers of a biblical text. If God gave the law to Moses to relay to the Israelites in the wilderness, in what sense is he giving that law to us today? And in what sense was he giving it to later generations of Israelites? If a Hebrew prophet utters an oracle specifically aimed at either Judah or Israel, what can such an oracle say to us? If Paul addresses a synagogue in Asia Minor, or writes a letter to Christians in the ancient city of Corinth, in what sense is he addressing us? In dealing with this as an aspect of the history gap, we must also take account of the continuing relevance of the Bible to us as the word of God. God is lord of history, so that his word spoken in and to a given ancient historical situation can still be intended to speak as his word to all generations. How the ancient text of the Bible is relevant to us is a concern of hermeneutics.")])])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Communication and its principles")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("One of the most basic assumptions in evangelical hermeneutics is that God has communicated by his word and that he is certainly capable of doing this in the way that meets his purpose of effective communication. At the quite basic and purely secular level, we observe that effective communication can be viewed in terms of a sender and a receiver, the signal sent and received, and ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("a level of common understanding.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN19",
      "id": "ap_NFIN19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" The assumption is that there is a meaningful link between what the communicator sends and what is received. In communication we thus identify certain basic dimensions:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("the communicator (behind the text: the author and his/her intentions);")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("the communicated message (inside the text: the meaning of the text as text);")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("the receiver (in front of the text: the reader’s presuppositions, culture and role in giving meaning).")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Our assumptions about the Bible require us to define these dimensions more closely.")]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-007"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The communicator")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The first question arises as to who the sender or communicator is. Is it God, whose word we believe the Bible to be? Or is it a number of different human beings whom we believe actually wrote or compiled the documents as we have them in the Bible? If we assume, on the basis of the Bible’s own testimony about itself, that God effectively revealed his word to the human authors, we need to clarify what we understand about those involved in this double authorship, and the relationship between them. While accepting the notion of divine inspiration, I do not intend to get into the area of the psychology of inspiration — that is, the subjective experience of the human authors. Some biblical documents, for example prophetic oracles, express the authors’ conviction of having ‘the word of the Lord’ coming to them, but rarely the subjective experience of this reception. Other documents, for example some New Testament epistles, may well have been penned without any sense on the part of the author that these were destined to be canonized as inspired Scripture."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN20",
      "id": "ap_NFIN20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-008"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The communication")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The second dimension is the message itself and the medium through which it is communicated. It should be noted that even basic theories of "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("communication would recognize that attempts to communicate can have varying degrees of success. For that reason some have suggested that it is more appropriate to refer to ‘address’ rather than communication. Hermeneutic theorists have emphasized the need to distinguish not only various kinds of address, but also the role of those addressed in the interpretative process.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Double authorship implies double receivership, for the human author presumably must receive the word that he will in turn address to others. Furthermore, once we allow the possibility of double authorship, we face many questions about the message. Not least of these is the form of the message and how that might relate to the intention of the author/s to communicate something. To what extent does the human manner of communication, and the human situations which constitute its context, affect the divine author’s intent? At the centre of much hermeneutic debate lie the questions of revelation and the sufficiency of human language and thought forms to reveal the truth of God. This goes to the heart of the question of the identity of the Bible as the word of God. Evangelicalism differs radically from neo-orthodoxy on this matter.")])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-009"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The receiver")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Third, there is the dimension of the receiver and what characteristics of the receiver must be accounted for in the matter of interpretation of meaning. What common understanding exists between the sender (God) and the receiver (human beings) that enables effective communication to take place? After all, we are quite aware of the fact that many people hear or read the biblical text but remain uncomprehending of its significance. According to the Bible itself, it is not only the cultural context of the reader/hearer that affects understanding, but also the opening of one’s mind through regeneration and faith.")])])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Divine communication")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("We can see that there are common concerns in the study of communication in a purely secular manner and the study of what purports to be divine communication. There are also some significant differences which have to do with the presuppositions and assumptions we make about all three dimensions (sender, message and receiver). An evangelical reading of the Bible proceeds on a number of assumptions concerning God, his word and us as receivers. How, then, do we arrive at such assumptions, and what confidence can we have in them? The usual evangelical assertion on biblical authority should be understood for what it is. We can state it thus: "), _c('i', [_vm._v("We believe the Bible to be the infallible word ")])]), _c('i', [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("of God because the Bible itself tells us that this is the case. ")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("The immediate objection is that this is a circular argument — which of course it is! But is it really different from saying we know that God is God because he says he is? Can circularity be avoided and, if so, how? There are those who suggest it can be avoided merely by refusing to make assumptions, and by allowing the evidence to speak for itself. But this is to make another set of assumptions about what constitutes evidence and how it does speak for itself. If we refuse to start with the assumption that the Bible tells the truth in claiming to be God’s word, we must start with another assumption: that it does not or may not tell the truth and, therefore, it is not or may not be God’s word. If we seek to avoid the obvious circularity of this latter approach by saying that we must test the Bible by certain objectively neutral facts, then who determines what is neutral and which facts are applicable? In the end, it becomes human reason that judges what is reasonable evidence about the nature of the Bible. As soon as we admit this, then we see that it is a choice of two opposing circular arguments: one that assumes the ultimate authority of God and his word, and the other that assumes the ultimate authority of unaided human reason. We must examine these two positions more closely in pursuing the basis of valid interpretation of the Bible. Perhaps it will emerge that one position is really an exercise in futility in that it undermines itself by its own assumptions.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The concept of the hermeneutical spiral can assist us to make a start in dealing with the Bible as God’s communication to mankind. We must make an assumption about the Bible and its significance and, on that basis, make a determined move to discover the dimensions of hermeneutics. As evangelicals we stand by a theology of the Word/word as central to our approach to the Bible. The Bible says such things as the following:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the beginning was the Word. (John 1:1)")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("And the Word became flesh and lived among us . . . full of grace and truth. (John 1:14) My sheep hear my voice, and I know them, and they follow me. (John 10:27)")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Evangelical hermeneutics can at least be described as gospel-driven. God has spoken by his Word, the Word who became a man for us. He knows us and we know his voice so that we follow him. Any hermeneutics that loses this plot has ceased to be evangelical and is out of touch with biblical truth. The evangelical interpreter must decide what assumptions are brought to bear on the subject of understanding the Bible, and to what degree we can apply non-biblical categories to our study without compromising our principles. The concept of communication involving the communicator, the message and the receiver suggests the following formal dimensions to the study of biblical hermeneutics.")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Diagram 1: The dimensions of divine communication to humans")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "frame": "box",
      "rules": "cols"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "43%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("COMMUNICATOR:"), _c('br'), _vm._v("\n                    GOD")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("THEOLOGICAL DIMENSION")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("COMMUNICATION:"), _c('br'), _vm._v("\n                    GOD’S WORD")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("CHRISTOLOGICAL ‘SALVATION"), _c('br'), _vm._v("\n                    HISTORY’ DIMENSION")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("Incarnate and"), _c('br'), _vm._v("\n                    inscripturate")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("LITERARY DIMENSION")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("RECEIVERS and"), _c('br'), _vm._v("\n                    PROCLAIMERS")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("ANTHROPOLOGICAL DIMENSION")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("HISTORY OF INTERPRETATION")])])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This analysis does not pre-empt the kind of synthesis we may come up with in the end, but it at least suggests a way of itemizing the individual areas of study that go to make up a comprehensive study of hermeneutics. The categories designated are not watertight and will, because of the nature of things, often overlap or interact. Thus Christology can be shown to be also at the heart of understanding the receivers of God’s word, in that Christ was the true receiver and interpreter of his Father’s word. Our true receiving of the word relates to our union with Christ the receiver. History writing and literature are both human activities, so the divine-human relationship is central to God’s word.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-010"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The communicator: God")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Christian theistic presuppositions include the acceptance that God is there, that he communicates with us through the Bible, and that, therefore, he is involved in the authorship of the Bible in such a way that it really does say what he intends. To this we must add the fact of our being created in the image of God, so that we are made to be able to receive and understand God’s communication. Consequently, our approach to interpretation will take account of these presuppositions. To ignore them is to repudiate them.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("This brings us to the theological question: what kind of God is it who communicates with us? Some theological liberals would appear to assume the unwillingness or the inability of God to make a good job of getting his message across to mere mortals! They assert that finite human language is incapable of expressing the infinite. Yet we have reason to suggest a correlation between the refusal to allow that Jesus was truly God as well as the ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("clearest word of God to humanity, and the refusal to allow that the human words of an inspired Bible are able to communicate divine truth.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-011"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The communication: God’s word")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When we talk about God’s word we have something of a dilemma. There are two distinct, if related, ways of identifying God’s word. We speak of both Jesus Christ and the Bible as God’s word. Putting an upper-case W on Word when we speak about Jesus as the Divine Word may remove some ambiguity, but we need to understand the relationship between the two. Jesus is the Word of God incarnate. He is the revealer, communicator and saviour. How we understand Jesus will affect the way we understand the communication of God in the Bible, but we only understand Jesus as the Word through the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The Bible is a book and as such must be treated as a book. How does this reflect the nature of Jesus? Our presuppositions about Jesus and the Bible are crucial. Again we face the question of circularity. If the Bible is God’s book, how do the dimensions of human authorship and the cultural and historical contexts of the Bible affect its meaning and our understanding? We may propose that the relationship of the divine and human natures in the person of Jesus provide a paradigm for understanding the relationship of the divine and human words in the Bible. That is, we go to the Bible to find the necessary data for understanding the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("We will need to revisit later the question of the relationship of God’s word to human words. To assert that no human language is adequate to express the truth about God can be an exercise in evasion. Of course we accept that human minds, human thought forms and human language can never plumb the depths and the mysteries of infinite divine Being. But we also recognize that our personhood, our thought forms and our language have their origins in God, as he created us in his image. We are finite and limited by our humanness, but we reflect the image of God nevertheless. Thus we can make a distinction between absolute and exhaustive knowledge of the truth, which only God has, and true though finite knowledge, which we are created to have.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-012"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("The receivers: God’s people")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Our presuppositions about humanness and the relationship of humanity to God will affect the way we understand ourselves as interpreters of the Bible. We cannot avoid the question of human sin and its effects on our ability to receive and to know the truth. Biblical assertions about the effect of sin on our minds are not our only concern. What the Bible says about the effect of salvation on our minds is integral to hermeneutics. Hearing and understanding ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("the address of God to us is part of the saving process. The relevance of the ministry of the Holy Spirit to hermeneutics then becomes an issue. What, then, can we say about receivers who do not acknowledge the truth and authority of the Bible? Can they in any sense understand it truly? Some would say that the difference between believer and unbeliever is in submission to the authority of the word. Others argue that submission brings enlightenment and understanding that rebellion forgoes.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("How can we know what the Bible means, and how can we communicate this meaning to others? We believe a rational, communicating God has made us in his image as rational, communicating people. But what processes are involved in our communicating? If the Bible is the divine word using human words and thought forms, how do we penetrate to the human authors’ meaning and, through it, to the divine author’s meaning? We will examine various approaches to this basic question and attempt to express the role of the gospel in this process.")])])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("The dimensions of hermeneutics")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Given that the dimensions of communication at the very least involve the sender, the message and the receiver, what, if any, are the particular concerns of the evangelical interpreter of the Bible? Starting with the analysis set out in Diagram 1 (above), we may propose as a working hypothesis a range of dimensions that attach to each main category. These will not all have the same significance for the interpretative task, but it is well to err on the side of detail simply to show the interconnectedness of the matters that relate to the main dimensions. Diagram 2 (below), then, is suggestive rather than definitive. We must enquire in more detail into some of the main aspects of the presuppositional basis of hermeneutics in the next chapter. It will be apparent that hermeneutics is an integrative subject that embraces almost all areas of theological study.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN21",
      "id": "ap_NFIN21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Diagram 2: The theological dimensions of hermeneutics")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "3%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("COMMUNICATOR:"), _c('br'), _vm._v("\n                    GOD"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                    Question of the divine Author’s intended meaning")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("GOD")])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("1. His existence")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("2. What is his nature? — ontological")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("3. How does he manifest himself? — economic")])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• Trinity")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• Creator")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• Author of true rationality")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• Revealer to people")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• Judge and Saviour")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• Author of truth and meaning")])])])])])])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-004"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "frame": "box",
      "rules": "cols"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "3%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("COMMUNICATION:"), _c('br'), _vm._v("\n                    GOD’S WORD which includes interpretation of"), _c('br'), _vm._v("\n                    GOD’S ACTS"), _c('br'), _vm._v("\n                    (God’s speech-acts)"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("(The Word incarnate and the word inscripturate)")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("JESUS CHRIST")])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("1. Who and what is Jesus?")])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• God-Man")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• Redemptive revelation of the whole Bible")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• Word of God in the flesh")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• Mediator of salvation")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• Embodiment of truth and all meaning")])])])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("2. What did he achieve?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("3. How does he relate to the Bible?")])])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                    Question of the meaning of the text")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("THE BIBLE")])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("1. What is the Bible?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("2. How was it produced?")])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• relationship to history and culture")])])])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("3. How does it relate to God and his truth?")])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("• infallibility, inerrancy, inspiration")])])])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("4. What is authority?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("5. How does human language work?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("6. How can it be understood and applied?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("7. What is its unity and central message?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("8. What is its diversity?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("9. What are its canonical limits?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("10. Meaning: is it in the author, the text, the reader, or in all three?")])])])])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-005"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "3%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("RECEIVERS and"), _c('br'), _vm._v("\n                    PROCLAIMERS"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                    Question of the reader’s understanding of the text")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#f6f6f6"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("PEOPLE")])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("1. What is it to be created in the image of God?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("2. What are the noetic effects of sin?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("3. What are the noetic effects of regeneration?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("4. How can we know something truly?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("5. How can we know what the Bible means?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("6. What is our ultimate reference point for truth?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("7. How can we communicate the truth of the Bible?")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("8. Contextualization of the proclamation.")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('b', [_vm._v("9. How does the reader affect perceived meaning?")])])])])])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa1e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap2.vue
// module id = 78
// module chunks = 0